import BarFill from '@/components/charts/BarFill'
import { cn } from '@/lib/utils'

interface YearRangeTrackProps {
  /** Where today sits between the year's low (0) and high (100). */
  score: number
  /**
   * The ring that cuts the marker out of the surface under it (`ring-background` on the Market
   * rail, `ring-card` on the chart panel), and any hover styling the caller's group drives.
   */
  markerClassName: string
  /** The reading as a sentence, when the track is its only statement: it becomes an image. */
  label?: string | undefined
}

/**
 * The 52-week track: a neutral bar filled to today's level, with a dot marking it. Shared by the
 * Market rail's YearRangeCard and the chart panel's range block, so the two read as one control;
 * each caller prints its own ends under it and frames it its own way (a link and tip there, a
 * labelled image here).
 */
export default function YearRangeTrack({ score, markerClassName, label }: YearRangeTrackProps) {
  return (
    <span
      role={label === undefined ? undefined : 'img'}
      aria-label={label}
      className="relative mt-2 block h-2 w-full bg-foreground/16"
    >
      <BarFill
        className="absolute inset-y-0 left-0 bg-foreground/55"
        style={{ width: `${String(score)}%` }}
      />
      <span
        className={cn(
          'absolute top-1/2 size-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-foreground ring-3',
          markerClassName,
        )}
        style={{ left: `${String(score)}%` }}
      />
    </span>
  )
}
